import { Group } from '@mantine/core';

import classes from './FullWidthButtonGroup.module.css';

const FullWidthButtonGroup = ({
  children,
  wrap = 'wrap',
}: {
  children: React.ReactNode;
  wrap?: 'wrap' | 'wrap-reverse';
}) => {
  return (
    <Group gap="xs" wrap={wrap} className={classes.FullWidthButtonGroup}>
      {children}
    </Group>
  );
};

export { FullWidthButtonGroup };
